import React from "react"
import PropTypes from "prop-types"
import { Flex, Switch } from "antd"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { spacings } from "themes/variables"
import IconWithBg from "ui/IconWithBg"
import { Text } from "ui/Typography"
import styles from "./TicketTypeRow.module.css"

export const TicketTypeRow = ({ ticket, onToggle, onEdit, onDelete }) => (
  <Flex align="center" gap={16} className={styles.ticketRow}>
    <Switch checked={ticket.enabled} onChange={(checked) => onToggle(ticket.id, checked)} />
    <Text fw={500} className={styles.ticketTitle}>{ticket.title}</Text>
    <Text className={styles.ticketDescription}>{ticket.description}</Text>
    <Flex gap={spacings.XS} className="ml-auto">
      <IconWithBg icon={<EditOutlined />} onClick={() => onEdit(ticket)} />
      <IconWithBg icon={<DeleteOutlined />} onClick={() => onDelete(ticket.id)} />
    </Flex>
  </Flex>
)

TicketTypeRow.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    enabled: PropTypes.bool.isRequired,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
